import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class ModelosRemuneracaoService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchModelosRemuneracao({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(map(data => data.items));
  }
}
